<template>
    <order-layout>
      <router-view></router-view>
    </order-layout>
  </template>
  
  <script>
  export default {};
  </script>
  
  <style lang="scss" scoped>
  </style>